import { send_to_server } from '@/services/socketio_client_react/send_to_server';
import { ActionReducerMapBuilder, PayloadAction } from '@reduxjs/toolkit';
import { createAsyncThunkSafe } from '../_base/createAsyncThunkSafe';

import { ENUM__network_event_client_to_server } from '@shared/network/ENUM__network_event_client_to_server';
import { StateSearch } from './state_search';

export const remote_search_create = createAsyncThunkSafe<string, string>(
  ENUM__network_event_client_to_server.SEARCH_CREATE,
  async (workspace_id: string): Promise<string> => {
    return await send_to_server(ENUM__network_event_client_to_server.SEARCH_CREATE, workspace_id);
  },
);

export function init_remote_search_create(builder: ActionReducerMapBuilder<StateSearch>) {
  builder
    .addCase(remote_search_create.pending, (state, action) => {})
    .addCase(remote_search_create.rejected, (state, action) => {})
    .addCase(remote_search_create.fulfilled, (state, action: PayloadAction<string>) => {});
}
